import {
  LucideBrain,
  LucideBuilding2,
  LucideShield,
  LucideUsers,
} from 'lucide-react';

import { AdminLayout } from './_components/_layouts/AdminLayout';
import { AgentDetailView } from './_components/ai/_AgentDetailView';
import { AgentsListView } from './_components/ai/_AgentsListView';
import { AIUsageOrganizationDetailView } from './_components/ai/_AIUsageOrganizationDetailView';
import { AIUsageView } from './_components/ai/_AIUsageView';
import { OrganizationDetailView } from './_components/organizations/_OrganizationDetailView';
import { OrganizationsListView } from './_components/organizations/_OrganizationsListView';
import { UsersListView } from './_components/users/_UsersListView';
import { adminRoutes } from './routes';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

// Placeholder component for user details
const UserDetailsPlaceholder = () => (
  <div className="@UserDetailsPlaceholder p-8 text-center text-neutral/50">
    User Details - Coming Soon
  </div>
);

const routeDefs = createModuleRoutes({
  root: {
    path: adminRoutes.root,
    label: (t) => t.menu.admin.root,
    icon: LucideShield,
  },
  organizations: {
    path: adminRoutes.organizations,
    label: (t) => t.menu.admin.organizations,
    icon: LucideBuilding2,
    component: OrganizationsListView,
  },
  organizationDetails: {
    path: adminRoutes.organizationDetails,
    component: OrganizationDetailView,
  },
  users: {
    path: adminRoutes.users,
    label: (t) => t.menu.admin.users,
    icon: LucideUsers,
    component: UsersListView,
  },
  userDetails: {
    path: adminRoutes.userDetails,
    component: UserDetailsPlaceholder,
  },
  ai: {
    path: adminRoutes.ai,
    label: (t) => t.menu.admin.aiManagement,
    icon: LucideBrain,
  },
  aiAgents: {
    path: adminRoutes.aiAgents,
    label: (t) => t.menu.admin.aiAgents,
    icon: LucideBrain,
    component: AgentsListView,
  },
  aiAgentDetail: {
    path: adminRoutes.aiAgentDetail,
    component: AgentDetailView,
  },
  aiAgentNew: {
    path: adminRoutes.aiAgentNew,
    component: AgentDetailView,
  },
  aiUsage: {
    path: adminRoutes.aiUsage,
    label: (t) => t.menu.admin.aiUsage,
    icon: LucideBrain,
    component: AIUsageView,
  },
  aiUsageOrganizationDetail: {
    path: adminRoutes.aiUsageOrganizationDetail,
    component: AIUsageOrganizationDetailView,
  },
});

// prettier-ignore
const adminNav = createModuleNav(($) =>
  $(routeDefs.root, [
    $(routeDefs.organizations),
    $(routeDefs.organizationDetails),
    $(routeDefs.users),
    $(routeDefs.userDetails),
    $(routeDefs.ai, [
      $(routeDefs.aiAgents),
      $(routeDefs.aiAgentDetail),
      $(routeDefs.aiAgentNew),
      $(routeDefs.aiUsage),
      $(routeDefs.aiUsageOrganizationDetail),
    ]),
  ]),
);

export const adminModule = createAppModule({
  routes: routeDefs,
  nav: adminNav,
  layout: AdminLayout,
});
